import { useEffect, useRef } from "react";
import { Alert, Link as MuiLink } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { SuccessNotice } from "./types";

/**
 * Dismissible success Alert at the top of a detail page. Scrolls itself into
 * view when a new notice arrives (the form that triggered it may be far
 * down the page).
 */
const SuccessBanner = ({ notice, onClose }: { notice: SuccessNotice | null; onClose: () => void }) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (notice) ref.current?.scrollIntoView?.({ behavior: "smooth", block: "nearest" });
  }, [notice]);
  if (!notice) return null;
  return (
    <Alert ref={ref} severity="success" onClose={onClose} sx={{ mb: 2 }}>
      {notice.text}
      {notice.link ? (
        <>
          {". "}
          {notice.link.before}{" "}
          <MuiLink component={RouterLink} to={notice.link.to} sx={{ fontWeight: 700, color: "inherit" }}>
            {notice.link.label}
          </MuiLink>
        </>
      ) : null}
    </Alert>
  );
};

export default SuccessBanner;
